import { ElementTransformer } from '@lexical/markdown';
import {
  $isDiffHunkNode,
  DiffHunkNode,
} from '../customNodes/DiffHunkNode/DiffHunkNode';

const DIFF_LINE_REGEX = /^[+-] /;

// `dependencies` is exposed via a getter so that this module can participate
// in import cycles with `DiffHunkNode` (which happens whenever code that needs
// `LOAD_TRANSFORMERS` is pulled in through the DiffHunkNode chain). Reading
// `dependencies` happens lazily when Lexical registers the transformer, by
// which time `DiffHunkNode`'s class declaration has been evaluated.
export const DIFF_HUNK: ElementTransformer = {
  get dependencies() {
    return [DiffHunkNode];
  },

  export: node => {
    if (!$isDiffHunkNode(node)) {
      return null;
    }

    return `\`\`\`diff\n${node.__diffContent}\n\`\`\``;
  },

  regExp: DIFF_LINE_REGEX,

  replace: () => {
    // Import is handled by DiffHunkPlugin post-processing (same pattern as TABLE).
    return;
  },

  type: 'element',
};
